import {gql} from '@apollo/client';

export const MUTATION_CLIENT_SAVE = gql`
  mutation ClientSave($input: ClientSaveInput!) {
    clientSave(input: $input) {
      obj {
        id
      }
      errors {
        field
        messages
      }
    }
  }
`;
